import { useRef } from 'react';
import { useProcessAnimation } from '../hooks/useProcessAnimation';

const STEPS = [
  {
    number: 1,
    title: 'Free trial',
    text: 'We automate one real process in your business and track the impact.',
  },
  {
    number: 2,
    title: 'See the numbers',
    text: 'You get a clear picture of the time and effort it saves.',
  },
  {
    number: 3,
    title: 'Go live',
    text: "We agree on terms that reflect the value delivered, with ongoing reporting so you always know what you're paying for and what it's doing for you.",
  },
];

export function HowItWorks() {
  const sectionRef = useRef<HTMLDivElement>(null);
  useProcessAnimation(sectionRef);

  return (
    <section id="how" className="px-6 py-24">
      <div ref={sectionRef} className="mx-auto max-w-[1200px]">
        <span className="text-xs tracking-[0.3em] text-accent">02 — HOW IT WORKS</span>
        <h2
          data-reveal
          className="m-0 mb-[52px] mt-3.5 max-w-[16ch] font-display text-[clamp(30px,3.6vw,46px)] font-semibold tracking-[-0.02em]"
        >
          See the value before you commit.
        </h2>

        <div className="relative grid grid-cols-1 gap-8 min-[900px]:grid-cols-3 min-[900px]:gap-6">
          <div className="absolute left-[6%] right-[6%] top-[26px] hidden h-px bg-[var(--line)] min-[900px]:block" />
          <div
            data-process-fill
            className="absolute left-[6%] top-[26px] hidden h-px w-0 bg-accent shadow-[0_0_8px_rgba(208,119,24,0.7)] transition-[width] duration-[1100ms] ease-[cubic-bezier(0.4,0,0.2,1)] min-[900px]:block"
          />
          {STEPS.map((step) => (
            <div key={step.number} data-reveal className="relative">
              <div
                data-process-step={step.number}
                className="mb-6 flex h-[52px] w-[52px] items-center justify-center rounded-full border border-accent bg-bg font-display text-lg text-accent transition-[background,color,box-shadow] duration-500"
              >
                {step.number}
              </div>
              <h3 className="m-0 mb-2.5 font-display text-[21px] font-semibold">{step.title}</h3>
              <p className="m-0 text-balance text-base leading-[1.6] text-dim">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
